module.exports = __webpack_public_path__ + "assets/2147f595afebacafe3ce429841290e09.png";